<div class="flex flex-col h-full">
  <!-- Waiting for the server -->
  <div *ngIf="!isPageReady" class="flex flex-col flex-1 gap-3 items-center justify-center">
    <p-progressSpinner ariaLabel="loading" strokeWidth="4" [style]="{ width: '44px', height: '44px' }"></p-progressSpinner>
    <span class="text-sm" style="color: var(--p-text-muted-color)">The system counts the open job order details.</span>
  </div>

  <ng-container *ngIf="isPageReady">
    <!-- Scope and totals -->
    <div class="flex justify-between items-baseline gap-2 px-3 py-2 border-b shrink-0">
      <span class="text-sm font-semibold truncate">{{ scopeLabel }}</span>
      <span class="text-xs whitespace-nowrap" style="color: var(--p-text-muted-color)">
        {{ totalOpenCount | number }} open &middot; {{ totalValueAmt | currency: 'USD' : 'symbol' : '1.0-0' }}
      </span>
    </div>

    <div *ngIf="totalOpenCount > 0" class="flex flex-1 min-h-0 items-center gap-2 px-2">
      <!-- Donut: slices clockwise in bucket order, late share in the middle -->
      <div class="h-full min-h-0 shrink-0" style="width: 45%; min-width: 140px">
        <ag-charts [options]="options" style="width: 100%; height: 100%; display: block"></ag-charts>
      </div>

      <!-- The list doubles as the legend and carries every number -->
      <div class="flex-1 min-w-0 overflow-y-auto">
        <div class="grid grid-cols-12 gap-1 py-1 text-xs uppercase tracking-wide border-b"
             style="color: var(--p-text-muted-color)">
          <div class="col-span-5">Original Ship Date</div>
          <div class="col-span-4 text-right">Open Count</div>
          <div class="col-span-3 text-right">Value</div>
        </div>
        <div *ngFor="let b of buckets" class="grid grid-cols-12 gap-1 py-1.5 items-center border-b text-sm">
          <div class="col-span-5 flex gap-2 items-center min-w-0">
            <span class="inline-block shrink-0 rounded-full" style="width: 10px; height: 10px" [style.background-color]="b.color"></span>
            <span class="truncate">{{ b.label }}</span>
          </div>
          <div class="col-span-4 text-right whitespace-nowrap">
            {{ b.openCount | number }}
            <span style="color: var(--p-text-muted-color)">({{ b.openPct | number: '1.0-1' }}%)</span>
          </div>
          <div class="col-span-3 text-right">{{ b.openValueAmt | currency: 'USD' : 'symbol' : '1.0-0' }}</div>
        </div>
        <div class="grid grid-cols-12 gap-1 py-1.5 items-center text-sm font-semibold">
          <div class="col-span-5" style="padding-left: 18px">Total</div>
          <div class="col-span-4 text-right whitespace-nowrap">{{ totalOpenCount | number }}</div>
          <div class="col-span-3 text-right">{{ totalValueAmt | currency: 'USD' : 'symbol' : '1.0-0' }}</div>
        </div>
      </div>
    </div>

    <div *ngIf="totalOpenCount === 0"
         class="flex flex-1 items-center justify-center text-sm"
         style="color: var(--p-text-muted-color)">
      No job order detail is open.
    </div>
  </ng-container>
</div>
